<template>
<div>
    <van-button loading type="info" loading-text="加载中..." loading-type="spinner" />
</div>
</template>

<script>
export default {
    name: 'LoadPending',
    data() {
        return {
        }
    },
    created() {},
    methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
